<br>
<!-- Modal añadir gasto-->
<div class="modal fade" id="exampleModal3" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">AÑADIR GASTO PARA EL GASTO COD: [{{ codgas }}]</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label for="formGroupExampleInput">FECHA DE HOY</label>
                        <input type="text" class="form-control" name="fecha_hoy" id="fecha_hoy" value="{{fecha_hoy}}" readonly="readonly">
                    </div>
                    <div>
                        <label for="formGroupExampleInput">FECHA DEL TICKET</label>
                        <form class="form-inline">
                            <div class="form-group">
                                <div class="input-group">
                                <input class="form-control" placeholder="yyyy-mm-dd"
                                        name="FECHA_TICKET" [(ngModel)]="FECHA_TICKET" ngbDatepicker #d="ngbDatepicker">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                                </div>
                                </div>
                            </div>
                        </form>          
                    </div>
                    <!--
                    <div class="form-group">
                        <label for="formGroupExampleInput">FECHA TICKET</label>
                        <input type="text" class="form-control" [(ngModel)]="FECHA_TICKET" name="FECHA_TICKET" id="FECHA_TICKET" placeholder="2018-01-01">
                    </div>
                    -->
                    <div class="form-group">
                        <label for="formGroupExampleInput2">DETALLE</label>
                        <input type="text" class="form-control" [(ngModel)]="DETALLE" name="DETALLE" id="DETALLE" placeholder="CARGA DE COMBUSTIBLE..">
                    </div>

                    <div class="form-group">
                        <label for="formGroupExampleInput2">IMPORTE (numeros y punto para decimales)</label>
                        <input type="text" class="form-control" [(ngModel)]="IMPORTE" name="IMPORTE" id="IMPORTE" placeholder="674.50..">
                    </div>

                    <div class="form-group">
                        <label for="inputcategoria">CATEGORÍA</label>
                        <select [(ngModel)]="CATEGORIA" name="CATEGORIA" id="CATEGORIA" class="form-control">
                          <option *ngFor="let cat of dataSourceCategorias;" [value]="cat.codysub">{{ cat.detalle | uppercase}} ({{cat.codigo}}-{{cat.sub_codigo}})</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="formGroupExampleInput2">OBSERVACIONES</label>
                        <input type="text" class="form-control" [(ngModel)]="OBSERVACIONES" name="OBSERVACIONES" id="OBSERVACIONES" placeholder="DATO OBLIGATORIO SI NO HAY IMAGEN..">
                    </div>

                    <div class="input-group mb-3">
                        <button ng2FileSelect [uploader]="uploader" class="btn btn-primary" data-toggle="modal" data-target="#modalcaptura" >Subir imagen</button>
                    </div>
                    <div *ngIf="fotodetalle" style="height: 250px; width: 330px; text-align: center;" class="container">
                        <img id="ima" *ngIf="fotodetalle" src="{{fotodetalle}}" />
                        <p class="title">IMAGEN A SUBIR</p>
                        <div style="height: 250px; width: 330px; text-align: center;" class="overlay"></div>
                        <div class="button"><a style="cursor: pointer" (click)="quitarImagen()"> Quitar Imagen </a></div>
                    </div>
                
                </form>


            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button data-dismiss="modal" (click)="insertarNuevo()" href="#" routerLink="/verdetalles" type="button" class="btn btn-primary">+AÑADIR</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal VER DETALLE -->
<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header">
                <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">sub-gasto cod: [{{ codi_detalle_edit }}]</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <p style="font-style: italic; color:gray">Detalle: "{{ det_edit }}"</p>
                <p style="font-weight: bold">Importe: ${{ imp_edit }}</p>
                <p>Fecha_Ticket: {{ fec_edit | date:'dd/MM/yyyy' }}</p>
                <p>Obs: {{ obs }}</p>
                <hr>
            </div>
            <div id="fotitomodal">
                <img (click)="fullscreen()" id="fotocopia" src="{{ fotito }}">
                &nbsp;
                &nbsp;
                <br>
                <br>
                <br>
                <span (click)="rotate()" id="imgbajar">
                    <i id="imgbajar" class="material-icons">
                        repeat
                    </i>
                </span>
                <br>
            </div>
            <hr>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button *ngIf="estadoGasto != 'PAGADO'" data-dismiss="modal" (click)="enviarCodDetalle()" routerLink="/verdetalle" type="button" class="btn btn-primary">Editar!</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Subir imagen desde pc-->
<div class="modal fade" id="modalsubir" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div id="modalito" class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Acción</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
                </div>
                <div class="modal-body">
                    <div>
                        <input id="botonsubirarchivo" type="file" accept="image/*" class="form-control browse" ngModel (change)="getFiles($event)">
                        <br>
                    </div>
                    <div style="text-align: center; width:300; height:200px" *ngIf="fotob64">
                        <img style="width:300px; height:200px" src="{{fotob64}}">
                    </div>
                </div>
    
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button (click)="prendeCamara()" type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="!fotob64">Subir Imagen </button>
                </div>
            </div>
        </div>
    </div>
    

<!-- aca empieza el formulario -->

<div class="animated fadeIn" id="todo">
    <div class="col-lg-12">
        <app-loading class="m-5" *ngIf="loading"></app-loading>
        <div id="headerr">
            <h5>
                Gasto COD: [{{ codgas }}]
            </h5>
            <p style="font-weight: bold;">Descripción: "{{ detalleGasto }}"</p>
            <p>[{{dataSource.data.length}} sub-gastos] -- Total: ${{ tot_gasto }}</p>
            <p>Estado: {{ estadoGasto }}</p>
        </div>
        <hr>
        <!-- Button trigger modal 2 
        <button *ngIf="codi_detalle_edit" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal2">
            ver
        </button>
        -->
        <div id="grid" #TABLE>
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
            </mat-form-field>

            <div class="example-container mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>

                    <ng-container matColumnDef="COD_DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_DETALLE </th>
                        <td mat-cell *matCellDef="let element"> {{element.COD_DETALLE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_CARGA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_CARGA </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHA_CARGA | date:"dd/MM/yy"}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_TICKET">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_TICKET </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHA_TICKET | date:"dd/MM/yy"}} </td>
                    </ng-container>
                    <ng-container matColumnDef="DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element"> "{{element.DETALLE}}"</td>
                    </ng-container>
                    <ng-container matColumnDef="IMPORTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMPORTE </th>
                        <td style="font-weight: bold;" mat-cell *matCellDef="let element"> ${{element.IMPORTE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="CATEGORIA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CATEGORIA </th>
                        <td mat-cell *matCellDef="let element"> {{ element.CATEGORIA }} </td>
                    </ng-container>
                    <ng-container matColumnDef="OBSERVACIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OBSERVACIONES </th>
                        <td mat-cell *matCellDef="let element"> {{ element.OBSERVACIONES }} </td>
                    </ng-container>
                    <ng-container matColumnDef="IMAGEN">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMAGEN </th>
                        <td mat-cell *matCellDef="let element"> <img style="width: 50px; height: 50px;" src="{{element.IMAGEN}}"></td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="selectRow(row.COD_DETALLE,row.DETALLE,row.IMPORTE,row.FECHA_TICKET,row.IMAGEN,row.OBSERVACIONES)" data-toggle="modal" data-target="#exampleModal2" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

            <!-- Button trigger modal -->
            <button *ngIf="(estadoGasto != 'PAGADO') && (estadoGasto != 'AUTORIZADO')" type="button" class="btn btn-info btn-block" data-toggle="modal" data-target="#exampleModal3">
                + AÑADIR sub-gasto
            </button>
            <hr>
            <button class="btn-block" color="dark" mat-button (click)="exportAsExcel()" [disabled]="dataSource.data.length==0">Exportar a Excel</button>
            <a type="button" target="_blank" routerLink="/print-gastos" class="btn btn-success btn-block" mat-button (click)="imprimirGastos()" >IMPRIMIR GASTO {{ codgas }}</a>
        </div>
        <hr>
        <button type="button" class="btn btn-secondary btn-block" mat-button (click)="volver()" routerLink="/vergastos">Volver</button>
    </div>


</div>


<!-- Modal captura webcam (pc) -->
<div style="overflow-y: scroll;" class="modal fade" id="modalcaptura" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div id="modalito" class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">CAPTURE CON SU WEBCAM</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
                </div>
                <div class="modal-body" style="text-align: center">
                    <div>
                        <div>
                            <webcam id="webcamm" [height]="320" [width]="240" [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                                (initError)="handleInitError($event)"></webcam>
                            <br/>
    
                            <button style="height: 60px;" class="actionBtn btn btn-secondary" type="button" id="snap" (click)="triggerSnapshot()">¡CAPTURAR!</button>
                            <br/>
    
                        </div>
                    </div>
    
                    <div class="snapshot" *ngIf="webcamImage">
                        <h5>Imagen capturada</h5>
                        <img id="imacapturada" [src]="webcamImage.imageAsDataUrl" />
                    </div>
    
                    <h4 *ngIf="errors.length > 0">Messages:</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                    <!--
                        <video #video id="video" width="320" height="240" autoplay style="display:none"></video>
                        
                        <webcam width="320" height="240"></webcam>
                    </div>
                    <div style="text-align: center;">
                        <button style="height: 60px;" class="btn btn-secondary" type="button" id="snap" (click)="capture()">¡CAPTURAR!</button>
                    </div>
                    <hr>
                    <div style="text-align: center">
                        <canvas #canvas id="canvas" width="640" height="480"></canvas>
                        <ul>
                            <div style="text-align: center">
                                <li *ngFor="let c of captures">
                                    <img id="ulcaptura" src="{{ c }}" height="100px" />
                                </li>
                            </div>
    
                        </ul>
                    </div>
                -->
                </div>
    
                <div class="modal-footer" style="text-align: center;">
                    <button (click)="limpiacam()" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button (click)="snackCamara()" type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="!fotodetalle">Guardar Captura </button>
                </div>
            </div>
        </div>
    </div>
    